var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google 1",
    clipPath: "url(#clip0_1891_12734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.0935 9.91355L13.3042 9.91309C12.8719 9.91309 12.5215 10.2634 12.5215 10.6957V13.823C12.5215 14.2552 12.8719 14.6056 13.3041 14.6056H18.8169C18.2132 16.1722 17.0865 17.4842 15.6491 18.3178L17.9997 22.387C21.7704 20.2062 23.9997 16.3799 23.9997 12.0965C23.9997 11.4866 23.9548 11.0506 23.8649 10.5597C23.7965 10.1867 23.4727 9.91355 23.0935 9.91355Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0003 19.3043C9.30242 19.3043 6.94723 17.8303 5.68231 15.649L1.61328 17.9944C3.68398 21.5832 7.56308 24 12.0003 24C14.177 24 16.2309 23.4139 18.0003 22.3925V22.387L15.6496 18.3177C14.5744 18.9414 13.3302 19.3043 12.0003 19.3043Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18 22.3925V22.387L15.6494 18.3177C14.5741 18.9413 13.33 19.3043 12 19.3043V24C14.1767 24 16.2308 23.4139 18 22.3925Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.69566 12C4.69566 10.6702 5.05856 9.42613 5.68205 8.35096L1.61302 6.00562C0.586031 7.76938 0 9.81772 0 12C0 14.1824 0.586031 16.2307 1.61302 17.9945L5.68205 15.6491C5.05856 14.5739 4.69566 13.3298 4.69566 12Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.0003 4.69566C13.7595 4.69566 15.3755 5.32078 16.6377 6.36061C16.9491 6.61711 17.4017 6.59859 17.6869 6.31336L19.9027 4.09758C20.2263 3.77395 20.2033 3.24422 19.8575 2.94431C17.7428 1.10967 14.9912 0 12.0003 0C7.56308 0 3.68398 2.41673 1.61328 6.00558L5.68231 8.35092C6.94723 6.16969 9.30242 4.69566 12.0003 4.69566Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.6374 6.36061C16.9488 6.61711 17.4015 6.59859 17.6866 6.31336L19.9024 4.09758C20.226 3.77395 20.2029 3.24422 19.8573 2.94431C17.7425 1.10963 14.991 0 12 0V4.69566C13.7592 4.69566 15.3752 5.32078 16.6374 6.36061Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1891_12734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5f4ab8f15dfdc66c2842a9ae850f2542.svg";
export { ForwardRef as ReactComponent };